import React from 'react';
import { TouchableOpacity } from 'react-native';
import { Trans } from '@lingui/macro';
import { useNavigation } from '@react-navigation/native';
import styled from 'styled-components/native';

import FontIcon from '@src/components/FontIcon';
import Image from '@src/components/Image';
import Score from '@src/components/Score';
import Separator from '@src/components/Separator';
import { H2, Subtitle1, Subtitle2 } from '@src/components/Typography';
import { activeOpacity } from '@src/configuration/constants';
import { Book } from '@src/database/models';

type Props = {
  item: Book;
};

const Container = styled.View`
  flex-direction: row;
`;

const Star = styled(FontIcon).attrs({
  name: 'star-o',
  size: 14,
})``;

const Cover = styled(Image)`
  width: 100px;
  height: 130px;
  resize-mode: contain;
`;
const Content = styled.View`
  flex-direction: column;
`;

const CenterContent = styled(Content)`
  align-items: center;
`;

const Component: React.FC<Props> = ({
  item: { type, score, scoreCount, publisher, translator, title, id, coverUrl },
}) => {
  const navigation = useNavigation();
  const handlePress = React.useCallback(
    () => navigation.navigate('PrimeBookTextReader', { id }),
    [id, navigation]
  );

  return (
    <TouchableOpacity activeOpacity={activeOpacity} onPress={handlePress}>
      <Container>
        <CenterContent>
          <Cover
            source={
              coverUrl
                ? { uri: coverUrl }
                : require('@src/assets/images/cover.png')
            }
          />
          <Separator />
          <Score value={score} size={14} color="#ffc23a">
            <Star />
          </Score>
          <Subtitle2>
            <Trans>{scoreCount} Rating(s)</Trans>
          </Subtitle2>
        </CenterContent>
        <Separator />
        <Content>
          <H2>{title}</H2>
          <Separator />
          {publisher && (
            <H2>
              <Trans>Publisher: {publisher}</Trans>
            </H2>
          )}
          {translator && (
            <H2>
              <Trans>Translator: {translator}</Trans>
            </H2>
          )}
          <Separator />
          <Subtitle1>
            {type === 1 ? (
              <Trans>Text</Trans>
            ) : type === 2 ? (
              <Trans>Audio</Trans>
            ) : (
              <Trans>Text & Audio</Trans>
            )}
          </Subtitle1>
        </Content>
      </Container>
    </TouchableOpacity>
  );
};

Component.displayName = 'Card';

export default React.memo(Component);
